import React from 'react';
import { SectionWrapper } from '../../components';
import Carousel from '../../components/Carousel/Carousel';
import { SECTION } from '../../constants/sections';
import { Theme } from '../../constants/styles';

const Projects = () => {
  return (
    <SectionWrapper section={SECTION.projects} theme={Theme.Light}>
      <Carousel />
    </SectionWrapper>
  );
};

export default Projects;
